module.exports = __webpack_public_path__ + "img/LINKAJA.503a8927.svg";